import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Item } from "../items/item.entity";
import { EndCustomers } from "./end-customer.entity";

@Entity('brands')
export class Brands {

  @PrimaryGeneratedColumn("increment",{name:'brand_id'})
  brandId:number;
  @Column("varchar",{
    nullable:false,
    length:100,
    name:"brand_name"
    })
  brandName:string;
  
  
  @Column("int",{
    nullable:false,
    name:"end_customer_id"
    })
  endCustomerId:number;

  @Column("int",{
    nullable:false,
    name:"master_brand_id"
    })
  masterBrandId:number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default:"ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => EndCustomers, endCustomer => endCustomer.brandsInfo, { nullable: false, })
  @JoinColumn({ name: "end_customer_id" })
  endCustomerBrandsInfo: EndCustomers;

  @OneToMany(type=>Item, item=>item.brandsInfo)
  itemInfo:Item[];

}
